export default {"src":"/_next/static/media/markerAltIcon.9db54171.svg","height":18,"width":14,"blurWidth":0,"blurHeight":0};